import { useQuery } from '@tanstack/react-query';
import { fetchMeasurementApproval } from '@/integrations/faturamento/client';

/**
 * Quem aprovou a medição, em consulta própria — de propósito tolerante a falha.
 *
 * O detalhe da medição **não pode** depender desta resposta. Ela vem do faturamento-api
 * (GET /billing/cycles/{id}), outro serviço, outro deploy: se ele estiver fora ou recusar o
 * ciclo (404 para ciclo invisível ao gerador, RN-33), `retry: false` evita insistir num erro
 * que não é transitório, e o erro fica contido aqui: quem consome recebe `undefined` e
 * simplesmente não desenha a seção — o mesmo caminho de "ninguém aprovou".
 *
 * `staleTime` alto porque a aprovação é um fato: acontece uma vez e não muda. Ela é invalidada
 * pela mutation de aprovação, que é o único evento capaz de criá-la.
 */
export const useMeasurementApproval = (id: string | undefined) =>
  useQuery({
    queryKey: ['measurement-approval', id],
    queryFn: () => fetchMeasurementApproval(id!),
    enabled: !!id,
    retry: false,
    staleTime: 1000 * 60 * 5,
  });
